import React from "react";

const PromptClickView = (props) => {

  return (
    <p className="side-label">Click on a subregion of {props.trackName} to select repeats</p>
  );
};

export default PromptClickView;
